export const UOM_SUCCESS = 'UOM_SUCCESS';
export const UOM_SINGLE_SUCCESS = 'UOM_SINGLE_SUCCESS';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
